import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserGraduate,
  faFileExcel,
  faEnvelope,
  faInfoCircle,
  faQuestionCircle,
  faAlignJustify,
  faChartBar,
  faCodeBranch,
} from "@fortawesome/free-solid-svg-icons";
import {
  openEmail,
  openDownload,
  openInNewTab,
  generateIcon,
  generateSpanText,
  isFunction,
} from "./utilities.js";
import { getStateTwoDigitCode } from "./constants";

library.add(
  faUserGraduate,
  faFileExcel,
  faEnvelope,
  faInfoCircle,
  faQuestionCircle,
  faAlignJustify,
  faChartBar,
  faCodeBranch
);

// set top link address
function getBaseUrl() {
  let baseUrl = `${location.origin}${location.pathname}`;
  // no trailing slash
  return baseUrl.replace(/\/$/, "");
}
var headerText = document.getElementById("pseo-homepage-link");
headerText.href = getBaseUrl();

// title text
var headerText = document.getElementById("headertext");
headerText.innerHTML = "Post-Secondary Employment Outcomes Explorer ";

// Upper left icon and text
function userGraduate() {
  var faElement = document.createElement("i");
  faElement.className = "fas fa-user-graduate text-color graphics-icon";
  return faElement;
}

function titleText() {
  var textElement = document.createElement("span");
  textElement.className = "font-bold text-color graphics-text";
  textElement.innerHTML = " PSEO";
  return textElement;
}

var ugElement = document.getElementById("user-graduate");
ugElement.appendChild(userGraduate());
ugElement.appendChild(titleText());

// generate help button
function generateHelpButton(id, func, funcargs) {
  var buttonElement = document.createElement("button");
  buttonElement.type = "button";
  buttonElement.className = "btn btn-link align-top census-font info-link";
  buttonElement.id = id;
  buttonElement.addEventListener("click", function () {
    if (isFunction(funcargs)) {
      func(funcargs());
    } else {
      func(funcargs);
    }
  });
  return buttonElement;
}

// top right help buttons
var helpDiv = document.getElementById("help-buttons");

// popover modal dialog
let modalButton = document.createElement("button");
modalButton.id = "modal-button";
modalButton.type = "button";
modalButton.className = "btn btn-link align-top census-font info-link";
modalButton.setAttribute("data-toggle", "modal");
modalButton.setAttribute("data-target", "#guideModal");
helpDiv.appendChild(modalButton);

// popover modal doc
let modalDialog = document.createElement("div");
modalDialog.id = "guideModal";
modalDialog.className = "modal fade";
modalDialog.setAttribute("tabindex", "-1");
modalDialog.setAttribute("role", "dialog");
modalDialog.setAttribute("aria-labelledby", "exampleModalLabel");
modalDialog.setAttribute("aria-hidden", "true");

let modalDoc = document.createElement("div");
modalDoc.className = "modal-dialog modal-lg";
modalDoc.setAttribute("role", "document");

let modalContent = document.createElement("div");
modalContent.className = "modal-content";

let modalHeader = document.createElement("div");
modalHeader.className = "modal-header";

let modalTitle = document.createElement("h5");
modalTitle.className = "modal-title";
modalTitle.innerHTML = "What is PSEO?";
modalHeader.appendChild(modalTitle);

let modalClose = document.createElement("button");
modalClose.type = "button";
modalClose.className = "close";
modalClose.setAttribute("data-dismiss", "modal");
modalClose.setAttribute("aria-label", "Close");
modalClose.innerHTML = `<span aria-hidden="true">&times;</span>`;
modalHeader.appendChild(modalClose);

let modalBody = document.createElement("div");
modalBody.className = "modal-body";
let modalHeaderTitle = document.createElement("h3");
modalHeaderTitle.innerHTML = "Data Overview";
modalBody.appendChild(modalHeaderTitle);
let headerTextDiv = document.createElement("div");
headerTextDiv.setAttribute("id", "header-text-div");
let experimentalImg = document.createElement("img");
experimentalImg.setAttribute("src", "experimental-data.png");
experimentalImg.setAttribute("id", "experimental-logo");
headerTextDiv.appendChild(experimentalImg);
let modalHeaderText = document.createElement("span");
modalHeaderText.className = "inline";
modalHeaderText.innerHTML = `The Post-Secondary Employment Outcomes (PSEO) is an experimental data product from the US Census Bureau containing <strong>earnings</strong> outcomes and employment <strong>flows</strong> for recent graduates of partner colleges and universities. These statistics are generated by matching university transcript data with a national database of jobs. Only graduates who earn at least the annual equivalent of full-time work at the prevailing federal minimum wage and work three or more quarters in a calendar year are included.`;
headerTextDiv.appendChild(modalHeaderText);
modalBody.appendChild(headerTextDiv);
modalBody.appendChild(document.createElement("br"));
modalBody.appendChild(document.createElement("br"));
let modalEarningsTitle = document.createElement("h3");
modalEarningsTitle.innerHTML = "Earnings ";
let modalEarningsIcon = document.createElement("i");
modalEarningsIcon.className = "fas fa-chart-bar";
modalEarningsTitle.appendChild(modalEarningsIcon);
modalBody.appendChild(modalEarningsTitle);
let modalEarningsText = document.createElement("p");
modalEarningsText.innerHTML = `Earnings outcomes for graduates from a particular institution are available by degree field, degree level, and graduation cohort. The 25th, 50th, and 75th percentiles are released for
one, five, and 10 years after graduation.`;
modalBody.appendChild(modalEarningsText);

let modalFlowsTitle = document.createElement("h3");
modalFlowsTitle.innerHTML = "Flows ";
let modalFlowsIcon = document.createElement("i");
modalFlowsIcon.className = "fas fa-code-branch fa-rotate-90";
modalFlowsTitle.appendChild(modalFlowsIcon);
modalBody.appendChild(modalFlowsTitle);
let modalFlowsText = document.createElement("p");
modalFlowsText.innerHTML = `Employment Flows provide counts of graduates from a particular institution to the geographic location and/or industry of their main employer. Flows are available by degree field, degree level, and graduation cohort and are released for one, five, and 10 years after graduation.`;
modalBody.appendChild(modalFlowsText);

let modalQuestionsTitle = document.createElement("h3");
modalQuestionsTitle.innerHTML = "Contact Us";
modalBody.appendChild(modalQuestionsTitle);
let modalQuestionsText = document.createElement("p");
modalQuestionsText.innerHTML = `If you have any questions or comments contact us at <a target="_blank" href="mailto: CES.PSEO.Feedback@census.gov">CES.PSEO.Feedback@census.gov</a>.`;
modalBody.appendChild(modalQuestionsText);

let modalMailingListTitle = document.createElement("h3");
modalMailingListTitle.innerHTML = "Mailing List";
modalBody.appendChild(modalMailingListTitle);
let modalMailingListText = document.createElement("p");
modalMailingListText.innerHTML = `To get updates, including data releases and new partner institution announcements, join our mailing list below. Enter your email and tick the box for PSEO under <strong>Topic > Education</strong> <u>OR</u> <strong>Surveys/Program > Longitudinal Employer-Household Dynamics (LEHD)</strong>.`;
modalBody.appendChild(modalMailingListText);

let mailingListButtonDiv = document.createElement("div");
mailingListButtonDiv.className = "text-center";
let mailingListButton = document.createElement("a");
mailingListButton.className = "btn btn-outline-secondary";
mailingListButton.setAttribute(
  "href",
  "https://public.govdelivery.com/accounts/USCENSUS/subscriber/new"
);
mailingListButton.setAttribute("target", "_blank");
mailingListButton.setAttribute("role", "button");
mailingListButton.setAttribute("aria-pressed", "true");
mailingListButton.innerHTML = "Join the Mailing List";
mailingListButtonDiv.appendChild(mailingListButton);
modalBody.appendChild(mailingListButtonDiv);

let modalFooter = document.createElement("div");
modalFooter.className = "modal-footer";

let modalDismiss = document.createElement("button");
modalDismiss.type = "button";
modalDismiss.className = "btn btn-outline-secondary";
modalDismiss.setAttribute("data-dismiss", "modal");
modalDismiss.innerHTML = "Close";
modalFooter.appendChild(modalDismiss);

modalContent.appendChild(modalHeader);
modalContent.appendChild(modalBody);
modalContent.appendChild(modalFooter);

modalDoc.appendChild(modalContent);
modalDialog.appendChild(modalDoc);
document.body.appendChild(modalDialog);

let determineDownloadXLSX = () => {
  let stateName = $j33("#state-dropdown-button").text();
  let state = getStateTwoDigitCode(stateName).toLowerCase();
  return `https://lehd.ces.census.gov/data/pseo/latest_release/${state}/pseo_${state}.xlsx`;
};

// download data button
helpDiv.appendChild(
  generateHelpButton("download-button", openDownload, determineDownloadXLSX)
);
helpDiv.appendChild(
  generateHelpButton(
    "emailus-button",
    openEmail,
    "CES.PSEO.Feedback@census.gov"
  )
);
helpDiv.appendChild(
  generateHelpButton("tutorial-button", openInNewTab, "//youtu.be/bMThWNyhbe4")
);
helpDiv.appendChild(
  generateHelpButton(
    "help-button",
    openInNewTab,
    "/data/pseo_experimental.html#methodology"
  )
);

// top right button icons

modalButton = document.getElementById("modal-button");
var windowIcon = generateIcon("align-justify");
windowIcon.className += "icon-toggle-inactive";
modalButton.appendChild(windowIcon);
modalButton.appendChild(generateSpanText(" What is PSEO?"));

var downloadButton = document.getElementById("download-button");
var excelIcon = generateIcon("file-excel");
excelIcon.className += "icon-toggle-inactive";
downloadButton.appendChild(excelIcon);
downloadButton.appendChild(generateSpanText(" Download Data"));

var emailButton = document.getElementById("emailus-button");
var emailIcon = generateIcon("envelope");
emailIcon.className += "icon-toggle-inactive";
emailButton.appendChild(emailIcon);
emailButton.appendChild(generateSpanText(" Email Us"));

var tutorialButton = document.getElementById("tutorial-button");
var tutorialIcon = generateIcon("info-circle");
tutorialIcon.className += "icon-toggle-inactive";
tutorialButton.appendChild(tutorialIcon);
tutorialButton.appendChild(generateSpanText(" Tutorial"));

var helpButton = document.getElementById("help-button");
var helpIcon = generateIcon("question-circle");
helpIcon.className += "icon-toggle-inactive";
helpButton.appendChild(helpIcon);
helpButton.appendChild(generateSpanText(" Help"));
